import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    $(document.links)
        .filter((i, el) => !el.hasAttribute('target') && el.hostname !== window.location.hostname && !!el.hostname)
        .attr('target', '_blank');
});
